import { Text } from '../../../1elements'

const ViewItem = ({ item }) => {
    return (<Text style={{ overflowWrap: 'anywhere' }}>{item[0].fieldData}</Text>)
}

export default ViewItem
